import { render, staticRenderFns } from "./DocumentTargetControl.vue?vue&type=template&id=7541a45e&scoped=true"
import script from "./DocumentTargetControl.vue?vue&type=script&lang=js"
export * from "./DocumentTargetControl.vue?vue&type=script&lang=js"
import style0 from "./DocumentTargetControl.vue?vue&type=style&index=0&id=7541a45e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7541a45e",
  null
  
)

export default component.exports